import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#050d09] border-t border-[#C4A77D]/10">
      {/* Main Footer Grid */}
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">

          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 border border-[#C4A77D] flex items-center justify-center flex-shrink-0">
                <span className="text-[#C4A77D] font-serif text-xl">ر</span>
              </div>
              <div>
                <h2 className="text-sm font-light tracking-[0.2em] text-[#C4A77D] uppercase">Raha-ídúù</h2>
                <p className="text-[8px] tracking-widest text-gray-600 uppercase">Experience</p>
              </div>
            </Link>
            <p className="text-gray-500 text-sm font-light leading-relaxed max-w-xs mb-6">
              Elevating experiences, crafting dreams. Bespoke lifestyle management across Nigeria — Abuja, Lagos &amp; Calabar.
            </p>

          </div>

          {/* Services Column */}
          <div>
            <h3 className="text-[10px] tracking-[0.25em] uppercase text-[#C4A77D] mb-5">Services</h3>
            <ul className="space-y-3">
              {[
                { label: "Travel & Transport", href: "/#services" },
                { label: "Luxury Accommodations", href: "/#services" },
                { label: "Culinary Experiences", href: "/#services" },
                { label: "Private Events", href: "/events" },
                { label: "Curate Experience", href: "/curate-experience" },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-500 text-sm font-light hover:text-[#C4A77D] transition-colors duration-200">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-[10px] tracking-[0.25em] uppercase text-[#C4A77D] mb-5">Company</h3>
            <ul className="space-y-3">
              {[
                { label: "About Us", href: "/about" },
                { label: "Careers", href: "/about#careers" },
                { label: "Partnerships", href: "/about#partnerships" },
                { label: "Press & Media", href: "/press" },
                { label: "Contact", href: "/#contact" },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-500 text-sm font-light hover:text-[#C4A77D] transition-colors duration-200">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal + Locations Column */}
          <div>
            <h3 className="text-[10px] tracking-[0.25em] uppercase text-[#C4A77D] mb-5">Legal</h3>
            <ul className="space-y-3 mb-8">
              {[
                { label: "Privacy Policy", href: "/legal#privacy" },
                { label: "Terms & Conditions", href: "/legal#terms" },
                { label: "Cookie Policy", href: "/legal#cookies" },
                { label: "Disclaimer", href: "/legal#disclaimer" },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-500 text-sm font-light hover:text-[#C4A77D] transition-colors duration-200">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            <h3 className="text-[10px] tracking-[0.25em] uppercase text-[#C4A77D] mb-3">Locations</h3>
            <ul className="space-y-2">
              {["Abuja", "Lagos", "Calabar"].map((city) => (
                <li key={city} className="flex items-center gap-2 text-gray-500 text-sm font-light">
                  <span className="w-1 h-1 bg-[#C4A77D] rounded-full flex-shrink-0"></span>
                  {city}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="h-px bg-gradient-to-r from-transparent via-[#C4A77D]/20 to-transparent"></div>
      </div>

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-gray-600 text-xs font-light">
          &copy; {currentYear} Raha-ídúù. All rights reserved.
        </p>
        <p className="text-gray-700 text-xs font-light">
          Crafted with discretion &middot; Nigeria
        </p>
      </div>
    </footer>
  );
}
